<h1 class="page-title mb-5">أهم المؤشرات الاقتصادية</h1>
<div class="mb-5">
  <div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div class="mb-5">
          <div>
            <p>الناتج المحلي الإجمالي</p>
            <div class="gdp-container">
              <div *ngFor="let data of alldata" class="gdp-item">
                <p class="gdp-percentage">{{data.persentage}}</p>
                <p class="gdp-year">{{data.year}}</p>
              </div>
            </div>
          </div>
        </div>
        <highcharts-chart class="mb-5" [Highcharts]="Highcharts" [options]="chartOptions"
          style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        <highcharts-chart class="mb-5" [Highcharts]="LineHighchart" [options]="LinechartOptions"
          style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        <div class="dashboard">
          <div class="card">
            <h4>صافي تدفقات الاستثمار الأجنبي المباشر (% من الناتج المحلي الإجمالي)</h4>
            <h2>0.4%</h2>
            <span>(مليار دولار)</span>
            <select [(ngModel)]="selectedPeriod">
              <option *ngFor="let period of periods" [value]="period.value">
                {{ period.label }}
              </option>
            </select>
          </div>

          <div class="card">
            <h4>صافي تدفقات الاستثمار الأجنبي المباشر</h4>
            <h2>1.4</h2>
            <span>(مليار دولار)</span>

            <select [(ngModel)]="selectedPeriod">
              <option *ngFor="let period of periods" [value]="period.value">
                {{ period.label }}
              </option>
            </select>
          </div>

          <div class="card">
            <h4>صافي الاحتياطي الدولي</h4>
            <h2>40.7</h2>
            <span>(مليار دولار)</span>

            <select [(ngModel)]="selectedPeriod">
              <option *ngFor="let period of periods" [value]="period.value">
                {{ period.label }}
              </option>
            </select>
          </div>

          <div class="card">
            <h4>أهم الواردات</h4>
            <ul>
              <li>الآلات والمعدات</li>
              <li>قطع الغيار</li>
              <li>الأغذية</li>
              <li>الكيماويات</li>
              <li>البلاستيك</li>
              <li>المنتجات النفطية</li>
            </ul>
          </div>

          <div class="card">
            <h4>أهم الصادرات</h4>
            <ul>
              <li>منتجات زراعية</li>
              <li>منتجات كيميائية</li>
              <li>منتجات بترولية</li>
              <li>منتجات حديدية</li>
              <li>منسوجات</li>
            </ul>
          </div>

          <div class="card">
            <h4>معدل البطالة</h4>
            <h2>7.3%</h2>

            <select [(ngModel)]="selectedPeriod">
              <option *ngFor="let period of periods" [value]="period.value">
                {{ period.label }}
              </option>
            </select>
          </div>

        </div>


      </div>

      <div class="col-md-3">
        <app-fix-left-section></app-fix-left-section>
      </div>
    </div>
  </div>
</div>